import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import { firebaseConfig } from '../.env.js';

if(!app.apps.length) app.initializeApp(firebaseConfig);

export const firebaseAuth = app.auth();
export const cloudDB = app.database();
export const provider = new app.auth.GoogleAuthProvider();